import { useState, useEffect } from 'react';
import styles from './CookieBanner.module.scss';
import Button from '../Button';

const STORAGE_KEY = 'cookieAccepted';

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem(STORAGE_KEY);
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.banner}>
      <p className={styles.text}>
        Мы используем файлы cookie для аналитики посещаемости. Продолжая
        использовать сайт, вы соглашаетесь с{' '}
        <a href="/doc/Политика обработки файлов cookie.pdf" target="_blank" rel="noopener noreferrer" className={styles.link}>
          Политикой обработки файлов cookie
        </a>{' '}
        и{' '}
        <a href="/doc/Политика обработки и обеспечения безопасности персональных данных.pdf" target="_blank" rel="noopener noreferrer" className={styles.link}>
          Политикой обработки и обеспечения безопасности персональных данных
        </a>
      </p>
      <Button design="green" onClick={handleAccept} className={styles.button}>
        Хорошо
      </Button>
    </div>
  );
};

